// extracted by mini-css-extract-plugin
export default {"back-to-questions":"Answers_back-to-questions__NIDUz","question":"Answers_question__azAgX","see-more":"Answers_see-more__Gw0R0","reply":"Answers_reply__0AGTc"};